module.exports = __webpack_public_path__ + "static/media/refresh_overdue.e14470ef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/refresh_overdue.svg
// module id = 1970
// module chunks = 33